<template>
	<div class="editablelist">
		<ul>
			<slot></slot>
		</ul>
		<textButton @click.native="addItem(editablelist)"class="top-distance">新增</textButton>
	</div>
</template>
<script>
	export default {
		name: 'editablelist',
		props: {
			editablelist: {
				type: Array,
				default: function() {
					return [{},{}]
				}
			},
			text: {
				type: String,
				default: '添加'
			}
		},
		methods: {
			addItem(arr) {
				var newItem = {};
				arr.push(newItem)
			},
			deleteItem(item, arr) {
				arr.remove(item)

			}
		}
	}
</script>
<style lang="scss" scoped>
	@import '../../../docs/scss/variables';
	
	.editablelist {
		>ul >li { 
			overflow: hidden;
			position: relative;
			&:not(:nth-of-type(1)) {
				margin-top: 5px; 
			}
			.delete-btn {
				background: red;
				background: #f6f6f6;
				position: absolute; 
				right: 0px; 
				top: 0px;
				width: 30px; 
				@include border-left();
				margin: 1px 1px 0 0;
				height: calc(100% - 2px);

				.icon-trash {
					cursor: pointer;
					display: inline-block;
					padding: 9px 6px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					color: red;
					&:before { font-size: 16px; color: $font-light; transition: all .3s; }
					&:hover { &:before { color: $font-dark; } }

				} 
			}

		}

	}
</style>


// WEBPACK FOOTER //
// src/components/editablelist/editablelist.vue